module.exports = __webpack_public_path__ + "static/sui-modal-c8aa04b987d770e9439a72465e2b18a4.png";